
import { NavLink } from "react-router-dom";
import "./Navbar.css";
//import { useEffect, useRef, useState } from "react";
const Navbar=()=>{
 
    return(
    <nav className="navbar">
        <div className="navbar-container">
      <h2>My Website</h2>
      <ul>
        <li>
          <NavLink to="/">Home</NavLink>
        </li>
        <li>
          <NavLink to="/about">About</NavLink>
        </li>
        <li>
          <NavLink to="/services">Services</NavLink>
        </li>

        <li>
          <NavLink to="/contact">Contact</NavLink>
        </li>
       <li className="dropdown">
    <button className="dropbtn">
        Login ▼
    </button>

    <div className="dropdown-content">
        <a
            href="https://your-crm-url.com"
            target="_blank"
            rel="noopener noreferrer"
        >
            CRM Portal
        </a>
    </div>
</li>
      </ul>
      </div>
    </nav>
    )
};
export default Navbar;